import { post, postJson, get } from './axios'

const RESOURCE_BASE_PATH = '/members-api';

/*
 * 获取积分变更明细列表
 * */
export const getScoresList = p => postJson(`${RESOURCE_BASE_PATH}/shopBuyerListController/scores/list`, p);

/*
 * 获根据会员ID查询成长值变更明细列表接口
 * */
export const getGrowValueChangeRecord = p => postJson(`${RESOURCE_BASE_PATH}/growRuleController/getGrowValueChangeRecord`, p);


// 获取CDP会员列表
export const getCDPMemberList = p => postJson(`${RESOURCE_BASE_PATH}/shopBuyerListController/getCDPMemberList`, p);

// 获取绑定店铺列表
export const getShopList = p => post(`${RESOURCE_BASE_PATH}/bindAuthController/myList`, p);

//手动编辑积分
export const editScores = p => postJson(`${RESOURCE_BASE_PATH}/shopBuyerListController/scores`, p);

//手动编辑成长值
export const editGrow = p => postJson(`${RESOURCE_BASE_PATH}/growRuleController/changeGrowValue`, p);

//手动编辑等级
export const editGrade = p => postJson(`${RESOURCE_BASE_PATH}/shopBuyerListController/updateGrade`, p);


// 获取积分变更记录列表
export const getUpdateRecordPage = p => postJson(`${RESOURCE_BASE_PATH}/scoresCard/updateRecord/page`, p);

// 获取等级变更记录分页列表
export const getScoreGradeUpdateRecord = p => postJson(`${RESOURCE_BASE_PATH}/scoreGradeUpdateRecord/page`, p);
//导入记录-积分
export const getUploadFileRecord = p => get(`${RESOURCE_BASE_PATH}/ImportCusData/queryScoresUploadFileRecord`, p);
//导入记录-会员
export const getMemberUploadRecord = p => post(`${RESOURCE_BASE_PATH}/sysSellerUploadFile/queryUploadBuyerFileRecord`, p);

// 获取CDP会员详情
export const getCDPBuyerDetail = p => post(`${RESOURCE_BASE_PATH}/shopBuyerListController/getCDPBuyerDetail`, p);

// 修改CDP会员信息(姓名、性别、生日)
export const updateCDPBuyerBaseDetail = p => postJson(`${RESOURCE_BASE_PATH}/shopBuyerListController/updateCDPBuyerBaseDetail`, p);

// 导出文件
export const exportExcelURL = p => get(`${RESOURCE_BASE_PATH}/ImportCusData/getFileUrl`, p);

// 获取会员店铺详情
export const getMemberSellerManageDetail = p => postJson(`${RESOURCE_BASE_PATH}/shopBuyerListController/getMemberSellerManageDetail`, p);

// 根据订单获取用户信息
export const getMemberInfoDyOrderId = p => postJson(`${RESOURCE_BASE_PATH}/job/getMemberInfoDyOrderId`, p);

// 获取待发放积分列表
export const getPendingIntegralList = p => postJson(`${RESOURCE_BASE_PATH}/scoresCard/waitSendByOrder/list`, p);

// 同步积分和等级
export const syncPointAndGrade = p => postJson(`${RESOURCE_BASE_PATH}/shopBuyerListController/syncPointAndGrade`, p);

// 获取会员总览得数据概览数据
export const getMemberOverviewData = p => get(`${RESOURCE_BASE_PATH}/shopBuyerListController/getMemberStatsInfo`, p);

// 探测是否有运行中的查询任务
export const getRunningTask = () => get(`${RESOURCE_BASE_PATH}/expire/Scores/runningTask`);

// 提交即将到期积分查询
export const queryExpirePointMembers = p => postJson(`${RESOURCE_BASE_PATH}/expire/Scores/query`, p);

// 轮询查询结果
export const getQueryResult = p => get(`${RESOURCE_BASE_PATH}/expire/Scores/queryResult`, p);

// 保存为云雀静态人群
export const saveCrowd = p => postJson(`${RESOURCE_BASE_PATH}/expire/Scores/saveCrowd`, p);

// 获取会员黑名单列表
export const getMemberBlacklistList = p => postJson(`${RESOURCE_BASE_PATH}/scoresCard/memberBlacklist/list`, p);

// 移除会员黑名单
export const removeMemberBlacklist = p => postJson(`${RESOURCE_BASE_PATH}/scoresCard/memberBlacklist/remove?id=${p}`);

// 添加会员黑名单
export const createMemberBlacklist = p => postJson(`${RESOURCE_BASE_PATH}/scoresCard/memberBlacklist/create`, p);

// 更新会员卡等级行为升级规则
export const updateMemberGradeRule = p => postJson(`${RESOURCE_BASE_PATH}/scoresCard/grade/rule/save`, p);

// 获取云周系统跳转地址
export const getYunzhouSystemUrl = p => get(`${RESOURCE_BASE_PATH}/yunzhou-common/getYunzhouSystemUrl`, p);

// 导出跳转
export const getExportRedirectUrl = p => get(`${RESOURCE_BASE_PATH}/yunzhou-common/system-redirect`, p);
